import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import PersonIcon from '@material-ui/icons/Person';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import { blue } from '@material-ui/core/colors';
import { SuccessBankAccount, FailedBankAccount } from '../TopCard/icons';
const emails = ['username@gmail.com', 'user02@gmail.com'];
const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  infoDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  icon: {
    fontSize: 112,
    marginTop: 48,
    marginBottom: 48
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    color: "#0b1323",
  },
  subTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: "rgba(11, 19, 35, 0.5)",
    marginTop: 12
  },
  dialogV1: {
    borderRadius: '16px !important',
    paddingBottom: '32px !important'
  }
});

function FailureDialog(props) {
  const classes = useStyles();
  const { onClose,
    selectedValue,
    title,
    subTitle,
    preventAutoClose,
    open
  } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };
  const handleCheckDisableClose = () => {
    if(!preventAutoClose){
      onClose(selectedValue);
    }
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog fullWidth={true}
      onClick={handleCheckDisableClose}
      maxWidth={'xs'}
      onBackdropClick={handleCheckDisableClose}
      onClose={handleClose} aria-labelledby="success-dialog-title" open={open} classes={{ paperScrollPaper: classes.dialogV1 }}>
      <div className={classes.infoDiv}>
        <FailedBankAccount className={classes.icon} />
        {title && <Typography className={classes.title} >{title}</Typography>}
        {subTitle && <Typography className={classes.subTitle}>{subTitle}</Typography>}
      </div>
    </Dialog>
  );
}

FailureDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};
export default FailureDialog